import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, selectUser } from '../../../redux/slices/user';
import { EDIT_ACTION } from '../../../constants';

const AddUser = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * ユーザの新規作成
   */
  const handleAddUser = (): void => {
    dispatch(selectUser());
    dispatch(setDialogMode(EDIT_ACTION.CREATE));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddUser}>
      <i className="material-icons">add</i>
      {t('user.add')}
    </Button>
  );
};

export default AddUser;
